import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
      toast.success("You're in. Thank you — see you in your inbox.");
      setEmail("");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Something went wrong. Please try again.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      data-testid="newsletter-section"
      className="py-20 md:py-24 bg-terracotta text-cream"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-10 lg:px-14 text-center">
        <Mail size={32} className="mx-auto mb-6 text-cream/90" strokeWidth={1.5} />
        <h2
          data-testid="newsletter-heading"
          className="font-display text-3xl md:text-4xl lg:text-5xl leading-[1.1]"
        >
          The occasional letter —
          <br />
          <span className="italic">thoughtful, never noisy.</span>
        </h2>
        <p className="mt-5 text-lg text-cream/90 max-w-xl mx-auto">
          A monthly note on brand, design, accessibility, and what I'm curating for the
          Vintage Vault. Unsubscribe whenever.
        </p>

        <form
          onSubmit={onSubmit}
          data-testid="newsletter-form"
          className="mt-9 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            data-testid="newsletter-email-input"
            className="flex-1 px-5 py-4 text-navy text-base bg-cream placeholder:text-navy/40 focus:outline-none border-2 border-cream focus:border-mustard"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="newsletter-submit-button"
            className="bg-navy text-cream px-7 py-4 font-medium tracking-wide hover:bg-mustard hover:text-navy transition-colors disabled:opacity-60 border-2 border-navy hover:border-mustard"
          >
            {loading ? "Sending..." : "Subscribe"}
          </button>
        </form>
      </div>
    </section>
  );
}
